import { authenticatedMiddleware } from '../../permissions/middlewares/authenticatedMiddleware.js';
import { A } from '@adornis/base/env-info.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import { Recipient } from '@adornis/mails/entities/Recipient.js';
import { html } from 'lit';
import { Role } from '../../permissions/roles.js';
import { getGlobalPSBEmails, getRecipientForSchule, makeMartinusEmailTemplate } from '../../server/mailer.js';
import { getMartinusMailer } from '@martinus/mails/server/initMartinusMailer.js';
import { Person } from '../entities/person.js';

export const sendEntryFormFinishedNotification = registerMutation({
  operationName: 'sendEntryFormFinishedNotification',
  middlewares: [authenticatedMiddleware],
  type: () => Boolean,
  params: [
    { type: () => ID, name: 'schoolID' },
    { type: () => ID, name: 'personID' },
  ],
  resolve: (schoolID: string, personID: string) => async () => {
    const person = await getByID(
      Person,
      personID,
    )({
      _id: 1,
      email: 1,
      profilDaten: {
        stammdaten: {
          vorname: 1,
          nachname: 1,
        },
      },
    });

    if (!person) throw new Error('Die Person konnte nicht gefunden werden.');

    const localPSB = await getRecipientForSchule(Role.PSB, schoolID);
    const localSchulleiter = await getRecipientForSchule(Role.SCHULLEITER, schoolID);
    const globalPSB = await getGlobalPSBEmails();

    const message = {
      subject: `Sie haben das Anmeldeformular erfolgreich abgeschlossen`,
      html: await makeMartinusEmailTemplate(
        '',
        [
          `Hallo ${person.profilDaten?.stammdaten?.vorname} ${person.profilDaten?.stammdaten?.nachname},`,
          html`
            wir haben Ihre Daten erfolgreich gespeichert. Sie können diese jederzeit auf der Seite
            <a href="${A.absoluteUrl(`/personen/${personID}`)}">"Eigene Daten"</a> einsehen.
          `,
        ],
        schoolID,
      ),
    };

    await getMartinusMailer().send({
      message,
      recipients: new Recipient({ to: [person.email], bcc: [...localPSB, ...localSchulleiter, ...globalPSB] }),
    });
  },
});
